import React from "react";
import {
  AssetType,
  AssetFormData,
  ASSET_TYPE_LABELS,
  AIConversationContent,
} from "../../../types/asset-types";

export interface BaseAssetFormProps {
  data: AssetFormData;
  onChange: (data: AssetFormData) => void;
  errors?: Record<string, string>;
  disabled?: boolean;
}

export interface AIConversationFieldsProps {
  data: Partial<AIConversationContent>;
  onChange: (data: Partial<AIConversationContent>) => void;
  errors?: Record<string, string>;
  disabled?: boolean;
}

// AI Conversation Content Fields Component
export function AIConversationFields({
  data,
  onChange,
  errors = {},
  disabled = false,
}: AIConversationFieldsProps) {
  const handleChange = (field: keyof AIConversationContent, value: any) => {
    onChange({
      ...data,
      [field]: value,
    });
  };

  const handleKeywordsChange = (value: string) => {
    const keywords = value
      .split(",")
      .map((k) => k.trim())
      .filter((k) => k.length > 0);
    handleChange("keywords", keywords);
  };

  const handleConversationStartersChange = (value: string) => {
    const starters = value
      .split("\n")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    handleChange("conversationStarters", starters);
  };

  return (
    <div className="space-y-4">
      {/* <div className="border-t border-gray-200 pt-4">
        <h4 className="text-sm font-medium text-gray-900 mb-3">
          AI Conversation Content (Optional)
        </h4>
        <p className="text-xs text-gray-500 mb-4">
          Configure how AI chatbots will interact with users who scan this
          asset's QR code.
        </p>
      </div> */}

      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Topic
        </label>
        <input
          type="text"
          value={data.topic || ""}
          onChange={(e) => handleChange("topic", e.target.value)}
          disabled={disabled}
          placeholder="Main topic or theme for conversations"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        {errors?.topic && (
          <p className="mt-1 text-sm text-red-600">{errors.topic}</p>
        )}
      </div> */}

      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Content
        </label>
        <textarea
          value={data.content || ""}
          onChange={(e) => handleChange("content", e.target.value)}
          disabled={disabled}
          rows={3}
          placeholder="Key information or content to share with users"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        {errors?.content && (
          <p className="mt-1 text-sm text-red-600">{errors.content}</p>
        )}
      </div> */}

      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Context
        </label>
        <textarea
          value={data.context || ""}
          onChange={(e) => handleChange("context", e.target.value)}
          disabled={disabled}
          rows={2}
          placeholder="Additional context about this asset's purpose or location"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        {errors?.context && (
          <p className="mt-1 text-sm text-red-600">{errors.context}</p>
        )}
      </div> */}

      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Keywords
        </label>
        <input
          type="text"
          value={data.keywords?.join(", ") || ""}
          onChange={(e) => handleKeywordsChange(e.target.value)}
          disabled={disabled}
          placeholder="keyword1, keyword2, keyword3"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        <p className="mt-1 text-xs text-gray-500">
          Separate keywords with commas
        </p>
        {errors?.keywords && (
          <p className="mt-1 text-sm text-red-600">{errors.keywords}</p>
        )}
      </div> */}

      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Conversation Starters
        </label>
        <textarea
          value={data.conversationStarters?.join("\n") || ""}
          onChange={(e) => handleConversationStartersChange(e.target.value)}
          disabled={disabled}
          rows={3}
          placeholder="How can I help you today?&#10;What would you like to know about...?&#10;Are you interested in learning more?"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
        <p className="mt-1 text-xs text-gray-500">
          Enter each conversation starter on a new line
        </p>
        {errors?.conversationStarters && (
          <p className="mt-1 text-sm text-red-600">
            {errors.conversationStarters}
          </p>
        )}
      </div> */}
    </div>
  );
}

// Base form header component
export function AssetFormHeader({
  type,
  title,
  description,
}: {
  type: AssetType;
  title?: string;
  description?: string;
}) {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-900">
        {title || `Create ${ASSET_TYPE_LABELS[type]} Asset`}
      </h3>
      {description && (
        <p className="mt-1 text-sm text-gray-600">{description}</p>
      )}
    </div>
  );
}

// Common form field components
export function FormField({
  label,
  required = false,
  error,
  children,
  description,
}: {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  description?: string;
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {description && (
        <p className="text-xs text-gray-500 mb-2">{description}</p>
      )}
      {children}
      {error && error.trim() && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}

export function TextInput({
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  type = "text",
  "data-testid": dataTestId,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  type?: string;
  "data-testid"?: string;
}) {
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      data-testid={dataTestId}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    />
  );
}

export function TextArea({
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  rows = 3,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  rows?: number;
}) {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      rows={rows}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    />
  );
}

export function SelectInput({
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  required = false,
  "data-testid": dataTestId,
}: {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  "data-testid"?: string;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      required={required}
      data-testid={dataTestId}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export function NumberInput({
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  min,
  max,
  step,
  "data-testid": dataTestId,
}: {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;
  "data-testid"?: string;
}) {
  return (
    <input
      type="number"
      value={value ?? ""}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val === "" ? undefined : Number(val));
      }}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      min={min}
      max={max}
      data-testid={dataTestId}
      step={step}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    />
  );
}

export function CheckboxInput({
  checked,
  onChange,
  disabled = false,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded disabled:cursor-not-allowed"
    />
  );
}
